import { render } from "./LearningModal.vue?vue&type=template&id=58a18588"
import script from "./LearningModal.vue?vue&type=script&lang=js"
export * from "./LearningModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__